<template lang="pug">
.base-bloco-totalizador
    .base-bloco-totalizador__interno
        span
            slot(name='icone')
        span.base-bloco-totalizador__interno-texto {{ texto }}
    span.base-bloco-totalizador__interno-numero(v-if='numero') {{ numero }}
    span.base-bloco-totalizador__interno-numero(v-else)
        | -
</template>

<script>
export default {
    name: 'BaseBlocoTotalizador',
    props: {
        texto: {
            type: String,
            default: () => ''
        },
        numero: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.base-bloco-totalizador {
    min-width: 24%;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    padding: 20px 20px;
    .base-bloco-totalizador__interno {
        margin-right: 3px;
        display: flex;
        justify-content: center;
        align-items: center;

        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
        .lyra-icon {
            display: flex;
            padding-right: 0.5rem;
        }
        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 28px !important;
            background-color: var(--primary) !important;
            opacity: 0.7;
        }
    }
    .base-bloco-totalizador__interno-numero {
        flex-wrap: wrap;
        font-size: 18px;
    }
    span {
        padding: 3px;
        &.base-bloco-totalizador__interno-texto {
            max-width: 180px;
            font-weight: 500;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
@media only screen and (max-width: 1334px) {
    .base-bloco-totalizador {
        min-width: 48% !important;
    }
}
</style>
